export default __webpack_public_path__ + "static/media/Gotham-Pro.ca299782.woff2";